import { render, staticRenderFns } from "./Fiducia.vue?vue&type=template&id=21a80de7&"
import script from "./Fiducia.vue?vue&type=script&lang=js&"
export * from "./Fiducia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports